__turbopack_context__.v({
  "action": "actions-module-scss-module__NHa9Fa__action",
  "button": "actions-module-scss-module__NHa9Fa__button",
  "description": "actions-module-scss-module__NHa9Fa__description",
  "env": "actions-module-scss-module__NHa9Fa__env",
});
